import axios from 'axios';
import {cloneDeep} from 'lodash';
import React, {FC, useState} from 'react';
import {Dropdown} from 'semantic-ui-react';
import {DropdownOption} from './DataConst';

const VAL_BREAK = '*****';
const API_KEY = 'ak_ml9am4r7DpBGtL6uQhA0T3M1ounwc';
const POSTCODE_RE = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/;
const POSTCODE_ONLY_RE = /^(?:GIR\s?0AA|(?:[A-Z][0-9]{1,2}|(?:[A-Z][A-HJ-Y][0-9]{1,2}|(?:[A-Z][0-9][A-Z]|[A-Z][A-HJ-Y][0-9][A-Z]?)))\s?[0-9][A-Z]{2})$/i;
const OUTCODE_RE = /^(?:[A-Z][0-9]{1,2}|[A-Z][A-HJ-Y][0-9]{1,2}|[A-Z][0-9][A-Z]|[A-Z][A-HJ-Y][0-9][A-Z])$/i;
const OUTCODE_RE_REPLACE = /\b(?:[A-Z][0-9]{1,2}|[A-Z][A-HJ-Y][0-9]{1,2}|[A-Z][0-9][A-Z]|[A-Z][A-HJ-Y][0-9][A-Z])\b/gi;

interface DataAddressLookupProps {
  field;
  value: string;
  contactData;
  onChange;
}

const DataAddressLookup: FC<DataAddressLookupProps> = ({
  field,
  value,
  contactData,
  onChange,
}) => {
  const [selectedAddress, setSelectedAddress] = useState<string>('');
  const [searchOptions, setSearchOptions] = useState<DropdownOption[]>([]);

  const fetchPostcode = async (id: string) => {
    const url = `https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses/${id}/gbr?api_key=${API_KEY}`;

    const result = await axios.get(url);

    return result?.data?.result.postcode || '';
  };

  const handleAddressLookupSearch = async (search: string) => {
    const url = `https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses?api_key=${API_KEY}&query=${search}&context=GBR`;

    const results = await axios.get(url);

    if (!results?.data?.result?.hits) {
      setSearchOptions([]);
    }

    setSearchOptions(
      results?.data?.result?.hits?.map((r) => {
        let address = r.suggestion;

        // Format if searching for postcode
        if (POSTCODE_RE.test(search.trim())) {
          const match = search.match(POSTCODE_RE);
          const postcode = match ? match[0].toUpperCase() : null;
          console.log(postcode);

          address = `${r.suggestion.replace(
            OUTCODE_RE_REPLACE,
            '',
          )}${postcode}`;
        }

        console.log(address);

        return {
          value: `${r.id}${VAL_BREAK}${r.suggestion}`,
          key: r.suggestion,
          text: address,
        };
      }),
    );
  };

  console.log(searchOptions);

  const handleAddressSelection = async (value: string) => {
    const splitAddress = value.split(VAL_BREAK);

    const addressId = splitAddress[0];
    const splitAdd = splitAddress[1].split(', ');
    const address1 =
      splitAdd.length > 4 ? `${splitAdd[0]}, ${splitAdd[1]}` : splitAdd[0];
    const address2 =
      splitAdd.length === 3
        ? ''
        : splitAdd.length > 4
        ? splitAdd[2]
        : splitAdd[1];
    const address3 =
      splitAdd.length > 4
        ? splitAdd[3]
        : splitAdd.length === 3
        ? splitAdd[1]
        : splitAdd[2];
    let postCode = splitAdd[splitAdd.length - 1];

    if (!POSTCODE_RE.test(postCode)) {
      postCode = await fetchPostcode(addressId);
    }

    const clonedData = cloneDeep(contactData);

    clonedData.contact = {
      ...clonedData.contact,
      address: {
        address1: address1 || '',
        address2: address2 || '',
        address3: address3 || '',
        postalCode: postCode || '',
      },
    };
    clonedData['contact.address.address1'] = address1 || '';
    clonedData['contact.address.address2'] = address2 || '';
    clonedData['contact.address.address3'] = address3 || '';
    clonedData['contact.address.postalCode'] = postCode || '';

    setSelectedAddress(value);
    onChange(clonedData);
  };

  return (
    <Dropdown
      autoComplete={'off'}
      className={`positionIcon ${field.error ? 'error' : ''} ${
        field.lookup ? 'DropdownLookup' : ''
      }`}
      icon={field.icon || 'search'}
      placeholder={field.placeholder || `Type to search ${field.title}`}
      noResultsMessage={'Type to start searching.'}
      fluid
      search={(options, query) => {
        const tokens = query
          .toLowerCase()
          .trim()
          .split(/\s+/)
          .filter(Boolean);

        return options.filter((opt: any) => {
          const haystack = `${opt.text ?? ''} ${opt.key ?? ''} ${opt.value ??
            ''}`.toLowerCase();
          return tokens.every((t) => haystack.includes(t));
        });
      }}
      onSearchChange={(options, searchObj) =>
        handleAddressLookupSearch(searchObj.searchQuery)
      }
      selectOnBlur={false}
      selection
      value={selectedAddress || ''}
      onChange={async (e, data) => handleAddressSelection(data.value as string)}
      options={searchOptions}
    />
  );
};

export default DataAddressLookup;
